import React from 'react'
import cn from 'classnames'

import styles from './Text.module.css'

const Text = ({ size, children, className, style = {}}) => (
  <p className={cn(styles[size], className)} style={style}>
    {children}
  </p>
)

export default Text



// WEBPACK FOOTER //
// ./src/components/Text.js